import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Format stored match date/time for display in company timezone.
 * Stored values are UTC; convert for display (replaces legacy +1h UK offset).
 */
export function formatMatchDateTime(date, time, companyTimezone = 'UTC') {
  if (!date || !time) return { date: date || '', time: time || '' };
  const dt = dayjs.utc(`${date} ${time}`).tz(companyTimezone || 'UTC');
  return {
    date: dt.format('YYYY-MM-DD'),
    time: dt.format('HH:mm'),
  };
}
